/**
 * Coast Range — bridge Ride pub/sub + page context to Shopify Standard Events/Actions.
 * Depends on window.Shopify.StandardEvents loaded from the Shopify CDN module bootstrap.
 */
(function () {
  'use strict';

  function whenReady(cb) {
    if (window.Shopify && window.Shopify.StandardEvents) {
      cb(window.Shopify.StandardEvents);
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (window.Shopify && window.Shopify.StandardEvents) {
        clearInterval(timer);
        cb(window.Shopify.StandardEvents);
      } else if (tries > 40) {
        clearInterval(timer);
      }
    }, 50);
  }

  function pageMeta() {
    var meta = document.getElementById('coast-range-page-meta');
    if (!meta) return { template: '', title: document.title, url: window.location.href };
    return {
      template: meta.getAttribute('data-template') || '',
      title: meta.getAttribute('data-title') || document.title,
      url: meta.getAttribute('data-url') || window.location.href,
      productId: meta.getAttribute('data-product-id'),
      productHandle: meta.getAttribute('data-product-handle'),
      productTitle: meta.getAttribute('data-product-title'),
      variantId: meta.getAttribute('data-variant-id'),
      collectionId: meta.getAttribute('data-collection-id'),
      collectionHandle: meta.getAttribute('data-collection-handle'),
      collectionCount: meta.getAttribute('data-collection-count'),
    };
  }

  whenReady(function (SE) {
    if (typeof SE.createViewEventElement === 'function') {
      try {
        customElements.define('s-view-event', SE.createViewEventElement());
      } catch (e) {
        // Already defined
      }
    }

    document.addEventListener('DOMContentLoaded', function () {
      var meta = pageMeta();
      if (SE.PageViewEvent) {
        document.dispatchEvent(
          new SE.PageViewEvent({
            page: {
              template: meta.template,
              title: meta.title,
              url: meta.url,
            },
          })
        );
      }

      if (meta.template === 'product' && SE.ProductViewEvent && meta.productId) {
        var productRoot = document.querySelector('product-info') || document.getElementById('MainContent');
        if (productRoot) {
          productRoot.dispatchEvent(
            new SE.ProductViewEvent({
              context: 'page',
              product: {
                id: Number(meta.productId),
                title: meta.productTitle || '',
                handle: meta.productHandle || '',
                selectedVariant: meta.variantId
                  ? {
                      id: Number(meta.variantId),
                      availableForSale: true,
                    }
                  : null,
              },
            })
          );
        }
      }

      if (meta.template === 'collection' && SE.CollectionViewEvent) {
        var collectionRoot = document.querySelector('.collection') || document.getElementById('MainContent');
        if (collectionRoot) {
          collectionRoot.dispatchEvent(
            new SE.CollectionViewEvent({
              collection: {
                id: meta.collectionId ? Number(meta.collectionId) : null,
                handle: meta.collectionHandle || '',
                productsCount: meta.collectionCount ? Number(meta.collectionCount) : 0,
              },
            })
          );
        }
      }
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && SE.CartLinesUpdateEvent) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (payload) {
        var cartRoot =
          document.querySelector('cart-drawer') ||
          document.querySelector('cart-notification') ||
          document.querySelector('cart-items') ||
          document;
        var deferred = SE.CartLinesUpdateEvent.createPromise
          ? SE.CartLinesUpdateEvent.createPromise()
          : { promise: Promise.resolve({}), resolve: function () {}, reject: function () {} };

        cartRoot.dispatchEvent(
          new SE.CartLinesUpdateEvent({
            action: 'update',
            context: 'cart',
            lines: [],
            promise: deferred.promise,
          })
        );

        fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (ajaxCart) {
            var cart = SE.CartLinesUpdateEvent.createCartFromAjaxResponse
              ? SE.CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart)
              : ajaxCart;
            if (deferred.resolve) deferred.resolve({ cart: cart });
          })
          .catch(function (err) {
            if (deferred.reject) deferred.reject(err);
            if (SE.CartErrorEvent) {
              cartRoot.dispatchEvent(
                new SE.CartErrorEvent({
                  error: err && err.message ? err.message : 'Cart update failed',
                  code: 'INVALID',
                })
              );
            }
          });
      });
    }

    document.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest('[data-crc-destination]');
        if (!link) return;
        var detail = {
          destination: link.getAttribute('data-crc-destination') || '',
          articleId: link.getAttribute('data-crc-article-id') || '',
          articleHandle: link.getAttribute('data-crc-article-handle') || '',
          relatedId: link.getAttribute('data-crc-related-id') || '',
          relatedHandle: link.getAttribute('data-crc-related-handle') || '',
          href: link.getAttribute('href') || '',
        };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'crc_affiliate_click',
          crc_destination: detail.destination,
          crc_article_id: detail.articleId,
          crc_article_handle: detail.articleHandle,
          crc_related_id: detail.relatedId,
          crc_related_handle: detail.relatedHandle,
          crc_href: detail.href,
        });
        document.dispatchEvent(new CustomEvent('crc:affiliate-click', { detail: detail, bubbles: true }));
      },
      true
    );

    window.Shopify = window.Shopify || {};
    window.Shopify.actions = window.Shopify.actions || {};

    if (typeof window.Shopify.actions.configure === 'function') {
      window.Shopify.actions.configure({
        openCart: async function () {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
            return;
          }
          var notification = document.querySelector('cart-notification');
          if (notification && typeof notification.open === 'function') {
            notification.open();
            return;
          }
          window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
        },
      });
    } else {
      var originalOpen = window.Shopify.actions.openCart;
      window.Shopify.actions.openCart = async function () {
        var drawer = document.querySelector('cart-drawer');
        if (drawer) {
          if (typeof drawer.open === 'function') {
            drawer.open();
            return;
          }
          drawer.setAttribute('open', '');
          return;
        }
        if (typeof originalOpen === 'function') {
          return originalOpen.apply(this, arguments);
        }
        window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
      };
    }
  });
})();
